import { api } from '../../fetchWrapper';
import { API_ENDPOINTS, getEndpoint } from '../../apiConstants';

export interface MailSettingItem {
  createdBy: number | null;
  creationDate: number | null;
  lastUpdateDate: number | null;
  lastUpdatedBy: number | null;
  clientId: number;
  id: number | null;
  jobDetailId: number;
  mailInterval: number;
}

export interface MailSettingResponse {
  success: boolean;
  object: MailSettingItem;
  messages: any[];
}

export async function fetchMailSettings({
  clientCode,
  jobDetailId,
}: {
  clientCode: string;
  jobDetailId: number | string;
}): Promise<MailSettingItem[]> {
  const endpoint = getEndpoint(clientCode, API_ENDPOINTS.JOB.MAIL_SETTINGS);
  const params = { firstResult: -1, maxResult: 1, jobDetailId };
  const response = await api.get<MailSettingItem[] | any>(endpoint, params);
  return Array.isArray(response) ? response as MailSettingItem[] : [];
}

export async function updateMailSetting({
  clientCode,
  payload,
}: {
  clientCode: string;
  payload: { mailInterval: string | number; jobDetailId: number | string; clientId: number; id: number };
}): Promise<MailSettingResponse> {
  const endpoint = getEndpoint(clientCode, API_ENDPOINTS.JOB.MAIL_SETTING_UPDATE);
  return api.put<MailSettingResponse>(endpoint, payload);
}

export async function createMailSetting({
  clientCode,
  payload,
}: {
  clientCode: string;
  payload: { mailInterval: string | number; jobDetailId: number | string; clientId: number };
}): Promise<MailSettingResponse> {
  const endpoint = getEndpoint(clientCode, API_ENDPOINTS.JOB.MAIL_SETTING_CREATE);
  return api.post<MailSettingResponse>(endpoint, payload);
}

export async function deleteMailSetting({
  clientCode,
  id,
}: {
  clientCode: string;
  id: number;
}): Promise<void> {
  const endpoint = getEndpoint(clientCode, `${API_ENDPOINTS.JOB.MAIL_SETTING_DELETE}${id}`);
  await api.delete(endpoint);
}


